<template>
  <div>
    <div v-if="sModoCampo=='1'">
      <ContenedorCampos :titulo="sLabel"  :isObligatorio="bObligatorio?'1':'0'" :error="error" class="under-sec">
        <div v-for="(firma, index) in aFirmas" :key="index">
          <v-row>
            <v-col cols="6">
              <p>{{firma.Asistente}}</p>
            </v-col>
            <v-col cols="4">
              <img :src="firma.Base64" width="70%" @click="ampliar(firma.firma, firma.nombre)">
            </v-col>
            <v-col cols="2">
              <v-icon small color="red darken-2" @click="borrar(index)">mdi-delete</v-icon>
            </v-col>    
          </v-row>
        </div>
        <Signature @firmado="verFirma"></Signature>
        <AmpliarFoto 
          :fotoampliada="ftampliada" 
          :textoampliado="txtampliado" 
          v-model="showFoto"
        ></AmpliarFoto>
      <span v-if="bError" style="width: 100%;color: red;">La firma es obligatoria</span>
      </ContenedorCampos>
    </div>
    <div v-else>
      <div class="my-3">
          <span class="segundoEstiloTitulo">{{onValidarPlaceholder(sLabel)}}</span>
          <span v-if="bObligatorio" class="font-weight-bold ml-1 red--text">*</span>
      </div>
      <div v-for="(firma, index) in aFirmas" :key="index">
        <v-row align="center" justify="center" class="firma-item segundoEstilo" no-gutters>
          <v-col class="pa-0" style="height: 100%;">
            <div class="d-flex align-center justify-center " style="height: 100%; width: 100%; position: relative;">
              <img class="segundoEstiloImagen"  :src="firma.Base64">
              <v-icon 
                small 
                color="white" 
                @click="borrar(index)"
                class="delete-icon-red"
              >
                mdi-delete
              </v-icon>
            </div>
          </v-col>
        </v-row>
      </div>
      <Signature @firmado="verFirma" :sModoCampo="sModoCampo" v-if="aFirmas.length==0"></Signature>
      <AmpliarFoto 
        :fotoampliada="ftampliada" 
        :textoampliado="txtampliado" 
        v-model="showFoto"
      ></AmpliarFoto>
      <span v-if="bError" style="width: 100%;color: red;">La firma es obligatoria</span>
    </div>
  </div>
</template>
<script>
import ContenedorCampos from '@/components/dinamicos/ContenedorCampos.vue'
import DinamicosMixin from '@/mixins/dinamicosMixin.js'
import Signature from '@/components/dinamicos/compAuxiliares/signature.vue'
import AmpliarFoto from '@/components/dinamicos/compAuxiliares/AmpliarFoto.vue'
import HoraFecha from '@/utils/Hora_Fecha.js'
import { mapGetters } from 'vuex'
import APPutils from '@/utils/APPutils.js'

export default {
  name: 'FormFirma',
  mixins: [ DinamicosMixin ],
  props:{
    oAtributos:{
        type:Object,
        default:()=>{}
    },
    bObligatorio:{
        type: Boolean,
        default: false,
    },
    sLabel:{
        type: String,
        default: "",
    },
    sModoCampo:{
        type: String,
        default: "1",
    },
    bError:{
        type: Boolean,
        default: false,
    }
  },
  components: {
    ContenedorCampos,
    Signature,
    AmpliarFoto
  },
  data () {
    return {
      aFirmas : [],
      showFoto: false,
      ftampliada : null,
      txtampliado : null
    }
  },
  mounted () {
  },
  methods: {
    verFirma(oInfo){
      const auxFirma = {Base64: oInfo.data, Asistente: oInfo.nombre , Firma : `Signature_${HoraFecha.getNowFile()}.jpg` }
      this.aFirmas.push(auxFirma)
      if(this.getisAPP){
        APPutils.enviarFirma(JSON.stringify(auxFirma))
      }
    },
    borrar(index){
      this.aFirmas.splice(index, 1)
    },
    ampliar(val, text){
      this.showFoto = true
      this.ftampliada = val
      this.txtampliado = text
    },
    onValidarPlaceholder(sLabelTemp){
        if(sLabelTemp!=""){
            let aTempPlaceholder = sLabelTemp.split("$$");
            if(aTempPlaceholder?.length>0){
            this.sPlaceholderTemp = aTempPlaceholder[1]
            }
            return aTempPlaceholder[0]
        }
    }
  },
  computed: {
    ...mapGetters(['getisAPP'])
  },
  watch: {
    aFirmas(newFirmas){
      this.selectValue = newFirmas
      this.$emit("value",this.aFirmas);
    }
  }

}
</script>

<style lang="scss" scoped>
.segundoEstiloTitulo{
  color: #0056D3;
  font-size: medium;
}
.segundoEstilo{
  border: 2px solid #b3cdf2;
  background: white;
  border-radius: 10px;
  height: 100px;
}
.delete-icon-red {
  cursor: pointer;
  position: absolute;
  top: 4px;
  right: 4px;
  background: #F44336 !important;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-icon-red:hover {
  background: #D32F2F !important; /* Rojo más oscuro al hover */
  transform: scale(1.05);
  transition: all 0.2s ease;
}
.segundoEstiloImagen{
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}
</style>
    